import { render, staticRenderFns } from "./TextRimageL.vue?vue&type=template&id=78057fba"
import script from "./TextRimageL.vue?vue&type=script&lang=js"
export * from "./TextRimageL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports